export const EMAIL_PREVIEW_LINK_TARGET_CLASS = "email-campaign-top-link-preview-target";
export const EMAIL_PREVIEW_LINK_OUTLINE_WIDTH_PX = 2;
export const EMAIL_PREVIEW_LINK_OUTLINE_OFFSET_PX = 3;

const STYLE_ELEMENT_ID = "email-campaign-top-link-preview-target-style";

const TARGET_STYLE = `
.${EMAIL_PREVIEW_LINK_TARGET_CLASS} {
  outline: ${EMAIL_PREVIEW_LINK_OUTLINE_WIDTH_PX}px solid #98A2B3 !important;
  outline-offset: ${EMAIL_PREVIEW_LINK_OUTLINE_OFFSET_PX}px !important;
  border-radius: 8px !important;
}
`;

export function applyEmailPreviewLinkHighlight(doc: Document, target: HTMLElement | null): void {
  doc.querySelectorAll(`.${EMAIL_PREVIEW_LINK_TARGET_CLASS}`).forEach(element => {
    element.classList.remove(EMAIL_PREVIEW_LINK_TARGET_CLASS);
  });

  if (target == null) {
    return;
  }

  if (doc.getElementById(STYLE_ELEMENT_ID) == null) {
    const style = doc.createElement("style");
    style.id = STYLE_ELEMENT_ID;
    style.textContent = TARGET_STYLE;
    doc.head.appendChild(style);
  }

  target.classList.add(EMAIL_PREVIEW_LINK_TARGET_CLASS);
}

export function clearEmailPreviewLinkHighlight(doc: Document | null | undefined): void {
  if (doc == null) {
    return;
  }

  doc.querySelectorAll(`.${EMAIL_PREVIEW_LINK_TARGET_CLASS}`).forEach(element => {
    element.classList.remove(EMAIL_PREVIEW_LINK_TARGET_CLASS);
  });
  doc.getElementById(STYLE_ELEMENT_ID)?.remove();
}
